import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogConfigInterface } from 'projects/shared/src/lib/core/interfaces';

@Component({
    selector: 'app-confirm-dialog',
    template: `
    <app-dialog>
      <ng-container body>
        <p class="dialog-message" *ngIf="data.message">
          {{ data.message }}
        </p>
      </ng-container>

      <ng-container actions>
        <button
          mat-flat-button
          *ngIf="data.cancelBtn"
          (click)="onConfirm(false)"
        >
          {{ data.cancelBtn | translate | uppercase }}
        </button>

        <button
          mat-flat-button
          *ngIf="data.successBtn"
          color="primary"
          (click)="onConfirm(true)"
        >
          {{ data.successBtn | translate | uppercase }}
        </button>
      </ng-container>
    </app-dialog>
  `,
    standalone: false
})
export class ConfirmDialogComponent {
  constructor(
    private _dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfigInterface
  ) {}

  public onConfirm(result: boolean): void {
    this._dialogRef.close(result);
  }
}
